module.exports = __webpack_public_path__ + "54e6eeb64ad806a343c763d8372c1f60.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/Foto_Manja_Herrmann-8386_klein.jpg
// module id = 742
// module chunks = 0